import { PeakMark } from "./PeakMark";

const PHRASES = [
  "Useful beats complicated",
  "Real problems beat invented ones",
  "Ship, learn, improve",
  "Save time, reduce friction",
  "Built by a founder, not a committee",
];

const Ribbon = () => (
  <div className="flex shrink-0 items-center">
    {PHRASES.map((p) => (
      <span key={p} className="flex items-center">
        <span className="whitespace-nowrap px-8 font-display text-xl font-medium tracking-tight text-evergreen/70 sm:text-2xl">
          {p}
        </span>
        <PeakMark className="h-5 w-auto opacity-40" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div
    data-testid="editorial-marquee"
    aria-hidden="true"
    className="overflow-hidden border-b border-ink/5 bg-sage/50 py-6"
  >
    <div className="flex w-max animate-marquee">
      <Ribbon />
      <Ribbon />
    </div>
  </div>
);
